// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AddBookRouteImport } from './routes/add-book'
import { Route as BrowseRouteImport } from './routes/browse'
import { Route as ClubsRouteImport } from './routes/clubs'
import { Route as CompleteProfileRouteImport } from './routes/complete-profile'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ExchangesRouteImport } from './routes/exchanges'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FeedRouteImport } from './routes/feed'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as JourneyRouteImport } from './routes/journey'
import { Route as LibrariesRouteImport } from './routes/libraries'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MessagesRouteImport } from './routes/messages'
import { Route as MissionsRouteImport } from './routes/missions'
import { Route as MyBooksRouteImport } from './routes/my-books'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as RateAppRouteImport } from './routes/rate-app'
import { Route as RecommendationsRouteImport } from './routes/recommendations'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ShelvesRouteImport } from './routes/shelves'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as UpdatePasswordRouteImport } from './routes/update-password'
import { Route as AdminErrorsRouteImport } from './routes/admin.errors'
import { Route as BookIdRouteImport } from './routes/book.$id'
import { Route as BorrowIdRouteImport } from './routes/borrow.$id'
import { Route as EditBookIdRouteImport } from './routes/edit-book.$id'
import { Route as LibrariesIdRouteImport } from './routes/libraries.$id'
import { Route as RequestsIdRouteImport } from './routes/requests.$id'
import { Route as ShelvesIdRouteImport } from './routes/shelves.$id'
import { Route as UIdRouteImport } from './routes/u.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AddBookRoute = AddBookRouteImport.update({
            id: '/add-book',path: '/add-book',getParentRoute: () => rootRouteImport
          })
const BrowseRoute = BrowseRouteImport.update({
            id: '/browse',path: '/browse',getParentRoute: () => rootRouteImport
          })
const ClubsRoute = ClubsRouteImport.update({
            id: '/clubs',path: '/clubs',getParentRoute: () => rootRouteImport
          })
const CompleteProfileRoute = CompleteProfileRouteImport.update({
            id: '/complete-profile',path: '/complete-profile',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ExchangesRoute = ExchangesRouteImport.update({
            id: '/exchanges',path: '/exchanges',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FeedRoute = FeedRouteImport.update({
            id: '/feed',path: '/feed',getParentRoute: () => rootRouteImport
          })
const HistoryRoute = HistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => rootRouteImport
          })
const InviteRoute = InviteRouteImport.update({
            id: '/invite',path: '/invite',getParentRoute: () => rootRouteImport
          })
const JourneyRoute = JourneyRouteImport.update({
            id: '/journey',path: '/journey',getParentRoute: () => rootRouteImport
          })
const LibrariesRoute = LibrariesRouteImport.update({
            id: '/libraries',path: '/libraries',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MessagesRoute = MessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => rootRouteImport
          })
const MissionsRoute = MissionsRouteImport.update({
            id: '/missions',path: '/missions',getParentRoute: () => rootRouteImport
          })
const MyBooksRoute = MyBooksRouteImport.update({
            id: '/my-books',path: '/my-books',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const RateAppRoute = RateAppRouteImport.update({
            id: '/rate-app',path: '/rate-app',getParentRoute: () => rootRouteImport
          })
const RecommendationsRoute = RecommendationsRouteImport.update({
            id: '/recommendations',path: '/recommendations',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ShelvesRoute = ShelvesRouteImport.update({
            id: '/shelves',path: '/shelves',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const UpdatePasswordRoute = UpdatePasswordRouteImport.update({
            id: '/update-password',path: '/update-password',getParentRoute: () => rootRouteImport
          })
const AdminErrorsRoute = AdminErrorsRouteImport.update({
            id: '/admin/errors',path: '/admin/errors',getParentRoute: () => rootRouteImport
          })
const BookIdRoute = BookIdRouteImport.update({
            id: '/book/$id',path: '/book/$id',getParentRoute: () => rootRouteImport
          })
const BorrowIdRoute = BorrowIdRouteImport.update({
            id: '/borrow/$id',path: '/borrow/$id',getParentRoute: () => rootRouteImport
          })
const EditBookIdRoute = EditBookIdRouteImport.update({
            id: '/edit-book/$id',path: '/edit-book/$id',getParentRoute: () => rootRouteImport
          })
const LibrariesIdRoute = LibrariesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => LibrariesRoute
          })
const RequestsIdRoute = RequestsIdRouteImport.update({
            id: '/requests/$id',path: '/requests/$id',getParentRoute: () => rootRouteImport
          })
const ShelvesIdRoute = ShelvesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => ShelvesRoute
          })
const UIdRoute = UIdRouteImport.update({
            id: '/u/$id',path: '/u/$id',getParentRoute: () => rootRouteImport
          })





const LibrariesRouteChildren = {
  LibrariesIdRoute: LibrariesIdRoute
}

const LibrariesRouteWithChildren = LibrariesRoute._addFileChildren(LibrariesRouteChildren)




const ShelvesRouteChildren = {
  ShelvesIdRoute: ShelvesIdRoute
}

const ShelvesRouteWithChildren = ShelvesRoute._addFileChildren(ShelvesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AddBookRoute: AddBookRoute,BrowseRoute: BrowseRoute,ClubsRoute: ClubsRoute,CompleteProfileRoute: CompleteProfileRoute,ContactRoute: ContactRoute,ExchangesRoute: ExchangesRoute,FaqRoute: FaqRoute,FeedRoute: FeedRoute,HistoryRoute: HistoryRoute,InviteRoute: InviteRoute,JourneyRoute: JourneyRoute,LibrariesRoute: LibrariesRouteWithChildren,LoginRoute: LoginRoute,MessagesRoute: MessagesRoute,MissionsRoute: MissionsRoute,MyBooksRoute: MyBooksRoute,PrivacyRoute: PrivacyRoute,ProfileRoute: ProfileRoute,RateAppRoute: RateAppRoute,RecommendationsRoute: RecommendationsRoute,RegisterRoute: RegisterRoute,ResetPasswordRoute: ResetPasswordRoute,ShelvesRoute: ShelvesRouteWithChildren,TermsRoute: TermsRoute,UpdatePasswordRoute: UpdatePasswordRoute,AdminErrorsRoute: AdminErrorsRoute,BookIdRoute: BookIdRoute,BorrowIdRoute: BorrowIdRoute,EditBookIdRoute: EditBookIdRoute,RequestsIdRoute: RequestsIdRoute,UIdRoute: UIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)